/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getRepositories$Json } from '../fn/git-hub-repository/get-repositories-json';
import { GetRepositories$Json$Params } from '../fn/git-hub-repository/get-repositories-json';
import { getRepositories$Plain } from '../fn/git-hub-repository/get-repositories-plain';
import { GetRepositories$Plain$Params } from '../fn/git-hub-repository/get-repositories-plain';
import { GitHubRepositoryCto } from '../models/git-hub-repository-cto';

@Injectable({ providedIn: 'root' })
export class GitHubRepositoryService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getRepositories()` */
  static readonly GetRepositoriesPath = '/api/v1/github/repositories';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRepositories$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRepositories$Plain$Response(params?: GetRepositories$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GitHubRepositoryCto>>> {
    return getRepositories$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRepositories$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRepositories$Plain(params?: GetRepositories$Plain$Params, context?: HttpContext): Observable<Array<GitHubRepositoryCto>> {
    return this.getRepositories$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<GitHubRepositoryCto>>): Array<GitHubRepositoryCto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRepositories$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRepositories$Json$Response(params?: GetRepositories$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GitHubRepositoryCto>>> {
    return getRepositories$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRepositories$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRepositories$Json(params?: GetRepositories$Json$Params, context?: HttpContext): Observable<Array<GitHubRepositoryCto>> {
    return this.getRepositories$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<GitHubRepositoryCto>>): Array<GitHubRepositoryCto> => r.body)
    );
  }

}
